export default {
  app_title: "Fuel prices",
  fuel_label: "Fuel",
  fuel_95: "Petrol 95",
  fuel_98: "Petrol 98",
  fuel_diesel: "Diesel",
  region_label: "Region",
  region_all: "All Spain",
  list_header: "Cheapest fuel nearby",
  list_show_all: "Show all",
  list_empty: "No stations in this area",
  list_expand: "Expand list",
  list_collapse: "Collapse list",
  card_navigate: "Maps",
  locate_me: "Locate me",
  no_location_permission: "Location permission denied",
  loading: "Loading...",
  error_loading: "Error loading data",
  attribution: "© OpenStreetMap, CartoDB",
  expand_map: "Expand map",
  collapse_map: "Collapse map",
  station_count: "stations",
  gesture_hint: "Use two fingers to move the map",
};
